import { render, staticRenderFns } from "./reject.modal.vue?vue&type=template&id=5818cc18&scoped=true"
import script from "./reject.modal.vue?vue&type=script&lang=js"
export * from "./reject.modal.vue?vue&type=script&lang=js"
import style0 from "./reject.modal.vue?vue&type=style&index=0&id=5818cc18&prod&lang=scss&scoped=true"
import style1 from "./reject.modal.vue?vue&type=style&index=1&id=5818cc18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5818cc18",
  null
  
)

export default component.exports